module.exports = __webpack_public_path__ + "static/img/brees-2009-img-in-copy.abf8cb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-img-in-copy.jpg
// module id = FkJz
// module chunks = 1